export const fetchFollowings = {
  pathname: type => `/favorites/${type}`
}

export const updateFollowings = {
  pathname: ({ type }) => `/favorites/${type}`,
  method: 'PUT',
  headers: {
    'content-type': 'application/json',
  },
  body: ({ ids }) => ({ ids })
}
